import { InjectionToken } from '@angular/core';
import { AuthConfig } from '@auth0/auth0-angular/lib/auth.config';
import { MsalAuthEnvironmentConfig } from './msal-auth-config.interface';

export const EnvironmentInstanceToken = new InjectionToken<PaceEnvironment>('PaceEnvironment');

export interface PaceEnvironment {
    production: boolean;
    appId: string;
    apiBase: string;
    apiSapProxy: string;
    operateInMockMode: boolean;
    reportIssueSupportEmail: string;
    bundleIdentifierName: string;
    subscriptionServerPublicKey?: string;
    complaintsLinkPath?: string;
    auth0?: AuthConfig;
    msal?: MsalAuthEnvironmentConfig;
    subscribeNotificationsOverride?: string;
    appInsightsConnectionString?: string;
}
